module.exports = "/images/vendor/flag-icon-css/flags/4x3/sk.svg?b84444bf8d98e48c8b0055e54071d918";